export function isEmptyReactNode(node) {
  return node == null || typeof node == 'boolean' || typeof node == 'string' && node.length === 0;
}